interface ScanTaskUiStartDate {
  date: number;
  time: {
    hours: number;
    minutes: number;
  };
}

export function convertScanTaskStartDateDbValueToUiValue(startDate: number): ScanTaskUiStartDate {
  const milliseconds = new Date(startDate * 1000);
  return {
    date: startDate,
    time: {
      hours: milliseconds.getUTCHours(),
      minutes: milliseconds.getUTCMinutes(),
    },
  };
}

export function convertScanTaskStartDateUiValueToDbValue(startDate: ScanTaskUiStartDate): number {
  const milliseconds = new Date(startDate.date * 1000);
  return Math.floor(
    Date.UTC(
      milliseconds.getFullYear(),
      milliseconds.getMonth(),
      milliseconds.getDate(),
      startDate.time.hours,
      startDate.time.minutes
    ) / 1000
  );
}

export function getCurrentScanTaskStartDate(): ScanTaskUiStartDate {
  const currentDate = new Date();
  return {
    date: currentDate.getTime() / 1000,
    time: {
      hours: currentDate.getHours(),
      minutes: currentDate.getMinutes(),
    },
  };
}
